import { Component } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { CustomCapabilityConfigurationForm } from '../../../../../core/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialog } from '@angular/material/dialog';
import { RavenInformationDialogComponent } from './raven-information-dialog.component';

export const DEFAULT_SALES_COACH_GOAL_ID = 'DefaultSalesCoach';

@Component({
  selector: 'ai-sales-coach-capability-form',
  imports: [
    ReactiveFormsModule,
    MatSelectModule,
    MatOptionModule,
    TranslateModule,
    GalaxyFormFieldModule,
    MatRadioModule
],
  templateUrl: './sales-coach-capability-form.component.html',
})
export class SalesCoachCapabilityFormComponent extends CustomCapabilityConfigurationForm {
  constructor(private readonly dialog: MatDialog) {
    super();
  }

  showRavenDialog(): void {
    this.dialog.open(RavenInformationDialogComponent, {
      width: '600px',
    });
  }
}
